/*
 * Keyboard access for the .collection-list__products card tracks.
 *
 * Browsers do not make an overflow container focusable on its own, so a keyboard user
 * cannot arrow-scroll the slider — they can only tab through the cards inside it. This
 * adds tabindex="0" so the track itself is reachable, and arrow keys then scroll it.
 *
 * The attribute is driven by whether the track actually overflows rather than by a
 * breakpoint, which handles the desktop case for free: above 768px the same element is a
 * plain grid with nothing to scroll, so it gets no tabindex and adds no stray tab stop.
 *
 * role="group" and aria-label are static, so they live in snippets/collection-row.liquid.
 */
(() => {
  // The snippet emits one script tag per collection row; only the first needs to run.
  if (window.__productGridSliderKeyboard) return;
  window.__productGridSliderKeyboard = true;

  const SELECTOR = '.collection-list__products';

  const sync = (track) => {
    // 1px of slack: sub-pixel card widths leave a fractional overflow on a plain grid.
    if (track.scrollWidth - track.clientWidth > 1) {
      if (!track.hasAttribute('tabindex')) track.setAttribute('tabindex', '0');
    } else if (track.getAttribute('tabindex') === '0') {
      track.removeAttribute('tabindex');
    }
  };

  // Setting an attribute does not affect layout, so this cannot feed back into itself.
  const observer =
    'ResizeObserver' in window
      ? new ResizeObserver((entries) => entries.forEach((entry) => sync(entry.target)))
      : null;

  const init = () => {
    document.querySelectorAll(SELECTOR).forEach((track) => {
      sync(track);
      if (observer) observer.observe(track);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The theme editor replaces a section's markup wholesale on edit.
  document.addEventListener('shopify:section:load', init);
})();
